<div style="display:flex; justify-content: space-between; column-gap: 80px;">
  <div>
    <h2 mat-dialog-title translate><span translate>PRODUCTS.BUG</span> NR.{{ bug.BugID }} {{bug[localizedFields.get('Description')].toUpperCase()}}</h2>
  </div>
  <div>
    <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
  </div>
</div>
<mat-dialog-content>
  <p class="improvement-text mt-2rem">
      <span class="improvement-data-title"><span translate>PRODUCTS.STATUS</span>: </span>
      <span class="upper" translate>BUGS.STATUSES.{{ bug.BugsStatus }}</span>
  </p>

  <mat-divider></mat-divider>
  <p class="improvement-text mt-2rem">
      <span class="improvement-data-title"><span translate>PRODUCTS.SEVERITY</span>:</span>
      {{ getBugSeverityNr(bug) }}
  </p>

  <mat-divider *ngIf="getInquiriedByProducts(bug).length > 0"></mat-divider>
  <p class="improvement-data-title mt-2rem" *ngIf="getInquiriedByProducts(bug).length > 0"><span translate>COMMONS.PRODUCTS_BUG_SIGNALLED</span>:</p>
  <p class="improvement-text" *ngFor="let product of getInquiriedByProducts(bug)">- {{ product }}</p>

  <mat-divider></mat-divider>
  <p class="improvement-data-title mt-2rem"><span translate>PRODUCTS.RESOLVED</span>:</p>
  <p class="improvement-text" *ngFor="let product of getResolvedForProducts(bug)">- {{ product }}</p>

  <mat-divider *ngIf="bug[localizedFields.get('Tip')]"></mat-divider>
  <p *ngIf="bug[localizedFields.get('Tip')]" class="improvement-data-title mt-2rem"><span translate>PRODUCTS.TIP</span>:</p>
  <p *ngIf="bug[localizedFields.get('Tip')]" class="improvement-text">{{ bug[localizedFields.get('Tip')] }}</p>

  <mat-divider></mat-divider>
  <p class="improvement-data-title mt-2rem"><span translate>PRODUCTS.ANSWER</span>:</p>
  <p class="improvement-text">{{ bug[localizedFields.get('Text')] }}</p>

  <mat-divider></mat-divider>
  <div style="margin-top: 3rem">
    <p class="text-bold"><span translate>COMMONS.SEVERITY_DESCRIPTION</span></p>
    <table mat-table [dataSource]="dataSource" matSort class="gravity-table" >
      <ng-container matColumnDef="gravityNumber">
        <td class="td-code" mat-cell *matCellDef="let element"><span translate>PRODUCTS.SEVERITY</span> {{element.gravityNumber}} </td>
      </ng-container>
      <ng-container matColumnDef="gravityDescription">
        <td class="td-name" mat-cell *matCellDef="let element"> {{element.gravityDescription}} </td>
      </ng-container>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <div class="small">{{bugsReportReleseNotesDisclaimerDetail}}</div>
  </div>
  <mat-divider *ngIf="archiviedDocuments?.length > 0"></mat-divider>
  <p class="improvement-data-title mt-2rem" *ngIf="archiviedDocuments?.length > 0"><span translate>Allegati</span>:</p>
  <button *ngFor="let archiviedDocument of archiviedDocuments" mat-button (click)="downloadArchiviedDocument(archiviedDocument)" color="primary">
      <mat-icon>download</mat-icon>
      {{ archiviedDocument.Name }}
  </button>
</mat-dialog-content>
<div *ngIf="isLoading">
  <tb-loading></tb-loading>
</div>



